import http from "./http";
import { canReadApi, permissionsLoaded } from "./settingsNav";

// the data the first steps ask for: a user who can read all of it can also fill it in
const REQUIRED_APIS = [
  "general-settings",
  "countries/details",
  "companies",
  "warehouses",
];

// the lists of the store hold enabled items only or all of them with an `enabled` flag
const hasEnabled = (list) =>
  Array.isArray(list) &&
  list.some((item) => item.enabled === undefined || !!item.enabled);

/**
 * Are the required first steps data missing (true), complete (false), or is it not for this user
 * to decide (null: the permissions are not loaded, the user cannot fill the data in, or a request failed).
 */
export async function firstStepsPending(state) {
  const user = state.user;
  if (!permissionsLoaded(user)) {
    return null;
  }
  if (!REQUIRED_APIS.every((path) => canReadApi(path, user))) {
    return null;
  }
  if (
    !hasEnabled(state.languages) ||
    !state.defaultLanguage ||
    !hasEnabled(state.currencies) ||
    !hasEnabled(state.countries) ||
    !Array.isArray(state.warehouses) ||
    state.warehouses.length === 0
  ) {
    return true;
  }
  // the companies are not part of the login data
  try {
    const companies = await http.fetch(
      "/companies",
      null,
      false,
      null,
      null,
      false,
      false
    );
    return Array.isArray(companies) ? companies.length === 0 : null;
  } catch (e) {
    return null;
  }
}
